export default "__VITE_ASSET__BPCOkc_D__"